export default __webpack_public_path__ + "static/media/menu4.b6821920.svg";